import PropTypes from 'prop-types';
import { Box, Card, Stack, Typography } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/ConstructionOutlined';

// Contenido temporal para paginas aun no implementadas.
// Mantiene navegable el layout mientras se construye cada modulo.
export default function PagePlaceholder({ title, description }) {
  return (
    <Card sx={{ p: 5 }}>
      <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center', py: 6 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: 'primary.lighter',
            color: 'primary.dark',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ConstructionIcon fontSize="large" />
        </Box>
        <Typography variant="h5">{title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
          {description || 'Este módulo está en construcción. Próximamente estará disponible.'}
        </Typography>
      </Stack>
    </Card>
  );
}

PagePlaceholder.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};
